import React, { useState } from "react";
import { BallContainer, Ball, Title, BackBtn, PlayBtn } from "./AutoStyled";

export default ({
  balls,
  handleAbove,
  handleSelectedSpheres,
  selectedSpheres,
  handleAutoRoll,
  handleNotification,
  leftSpheres,
  handleAboveAnim,
  isDisabled,
  toggleIsDisabled,
  autoBoardBalls,
  // userSettings,
  audio,
}) => {
  const [playA, setPlayA] = useState(false);
  const [backA, setBackA] = useState(false);

  const Play = () => {
    if (selectedSpheres.length > 0 && selectedSpheres.length <= leftSpheres) {
      toggleIsDisabled(true);
      handleAutoRoll();
    } else if (selectedSpheres.length > leftSpheres) {
      handleNotification(
        "Your selection exceeds the number of available spheres"
      );
      toggleIsDisabled(false);
    } else {
      handleNotification("You must pick at least 1 sphere");
      toggleIsDisabled(false);
    }
  };
  const setAnimation = (a, b) => {
    if (a) {
      b(false);
      clearTimeout();
    } else {
      b(true);
      setTimeout(() => {
        b(false);
      }, 500);
    }
  };

  return (
    <>
      <BallContainer isDisabled={isDisabled}>
        {balls.map((ball, index) => (
          <Ball
            key={index}
            onClick={
              selectedSpheres.length < leftSpheres ||
              selectedSpheres.includes(ball)
                ? () => {
                    handleSelectedSpheres(ball);
                    audio.switch();
                  }
                : () =>
                    handleNotification(
                      "Your selection exceeds the number of available spheres"
                    )
            }
            className={selectedSpheres.includes(ball) && "selected"}
          >
            <span />
          </Ball>
        ))}
      </BallContainer>
      <Title>Select Spheres</Title>
      <PlayBtn
        playA={playA}
        isDisabled={isDisabled}
        onClick={() => {
          setAnimation(playA, setPlayA);
          audio.confirm();
          Play();
        }}
      >
        Start Game
      </PlayBtn>
      <BackBtn
        isDisabled={isDisabled}
        backA={backA}
        onClick={() => {
          setAnimation(backA, setBackA);
          autoBoardBalls(true);
          handleSelectedSpheres(false);
          audio.goBack();
          setTimeout(() => {
            handleAboveAnim(true);
            handleAbove("autoConfig");
          }, 100);
        }}
      >
        Back
      </BackBtn>
    </>
  );
};
